import { useSelector } from 'react-redux';
import { useGlobalErrorHandler } from './services/hooks/UI/useGlobalErrorHandler';
import LandingLayout from './layout/Landing/Landing';
import PlatformLayout from './layout/Platform/Platform';
import routes, { paths } from './routes';
import { useAuthentication } from './services/hooks';
import { Modal, Loading, Toast, ErrorBoundary } from './components';

import './styles/index.scss';

import useLoading from './services/hooks/UI/useLoading';

import classes from './App.module.scss';

function App() {
  const { globalLoading } = useSelector(state => state.UI);
  const { businessId, businesses } = useSelector(state => state.userData);
  const { isLoading: isLoadingAuthentication, isLogged } = useAuthentication();

  useGlobalErrorHandler();
  // Loading
  useLoading();

  const loadingClass = classes[globalLoading ? 'loading-show' : 'loading-hide'];

  let routesLoged = routes.platform;
  if (businesses[businessId]?.businessDemographyIsComplete && businesses[businessId]?.sourceBankAccountIsConnected) {
    routesLoged = routes.platform.filter(({ path }) => path !== paths.completeRegister);
  }

  return (
    <ErrorBoundary>
      {isLoadingAuthentication ? (
        <div></div>
      ) : (
        <>
          {isLogged ? (
            <PlatformLayout routes={routesLoged} redirect="/itemssuppliers#invoices#payable" />
          ) : (
            <LandingLayout routes={routes.landing} redirect={paths.login} />
          )}
        </>
      )}
      <Modal />
      <Toast />
      <Loading className={loadingClass} globalLoading={globalLoading} />
    </ErrorBoundary>
  );
}

export default App;
